// write a component that uses VALUE_ACCESSOR that allows a parent to bind a form control to an input in this component

import { Component, ElementRef, HostBinding, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationDialogService } from './confirmation-dialog.service';
import { ConfirmationDialogResponse } from './confirmation-dialog-response.enum';

@Component({
  selector: 'prism-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})

export class ConfirmationDialogComponent implements OnInit, OnDestroy {

  private previouslyFocusedElement: HTMLElement | null = null;

  constructor(
    public confirmationDialogService: ConfirmationDialogService,
    private readonly elementRef: ElementRef<HTMLElement>,
  ) { }

  ngOnInit(): void {
    this.previouslyFocusedElement = document.activeElement instanceof HTMLElement
      ? document.activeElement
      : null;
    setTimeout(() => {
      this.recalculateDialogPosition();
      this.focusableElements()[0]?.focus();
    });
  }

  ngOnDestroy(): void {
    this.previouslyFocusedElement?.focus();
  }

  public submitResponse(response: ConfirmationDialogResponse) {
    this.confirmationDialogService.response$.next(response)
  }
  @HostBinding('style.--child-scale')
  get childScale() {
    return this.confirmationDialogService.styleVariableScale; // Return the input value
  }

  @HostListener('window:resize', ['$event'])
  public recalculateDialogPosition() {
    let elem = document.querySelector("#confirmation-dialog") as HTMLDivElement

    elem.style.left = ((window.innerWidth / 2) - (elem.clientWidth / 2)).toString() + "px"
    elem.style.top = ((window.innerHeight / 2) - (elem.clientHeight / 2)).toString() + "px"
  }

  @HostListener('document:keydown', ['$event'])
  public trapFocus(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    const focusable = this.focusableElements();
    if (!focusable.length) return;
    const currentIndex = focusable.indexOf(document.activeElement as HTMLElement);
    const nextIndex = event.shiftKey
      ? (currentIndex <= 0 ? focusable.length - 1 : currentIndex - 1)
      : (currentIndex < 0 || currentIndex === focusable.length - 1 ? 0 : currentIndex + 1);
    event.preventDefault();
    focusable[nextIndex].focus();
  }

  private focusableElements(): HTMLElement[] {
    return Array.from(this.elementRef.nativeElement.querySelectorAll<HTMLElement>(
      'button:not([disabled]), [tabindex]:not([tabindex="-1"])',
    )).filter(element => element.offsetParent !== null);
  }

}
